import { render, staticRenderFns } from "./3D.vue?vue&type=template&id=f18dcdfa"
import script from "./3D.vue?vue&type=script&lang=js"
export * from "./3D.vue?vue&type=script&lang=js"
import style0 from "./3D.vue?vue&type=style&index=0&id=f18dcdfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports